import styled from 'styled-components';

export const Container = styled.div`
  box-sizing: border-box;
  width: fit-content;
`;

export const Dot = styled.div`
  border-radius: 8px;
  box-sizing: border-box;
  display: inline-block;
  height: 18px;
  padding: 1px;
  width: 18px;

  > div {
    border-radius: 8px;
    color: black;
    height: 16px;
    text-align: center;
    width: 16px;
  }

  &.cyan > div {
    background-color: #03a4f0;
  }

  &.magenta > div {
    background-color: #f7448b;
  }

  &.yellow > div {
    background-color: #ffd906;
  }

  &.black > div {
    background-color: #000000;
    color: #ffffff;
  }
`;
